<template>
    <div class="checkbox">
        <p>{{this.desc}}</p>
        <label class="switch">
            <input type="checkbox" :disabled="this.disable" v-model="state" >
            <div class="slider" @click="hdlSwitch"></div>
        </label>
    </div>
</template>

<script>
export default {
  name: 'CheckBox',
  props: ['desc', 'value', 'disable'],
  data() {
    return {
      state: this.value,
    }
  },
  watch:{
    value(v){
      setTimeout(()=>{this.state = v}, 1) //hackish way since state does not change value
    }
  },
  methods: {
    hdlSwitch() {
      if(!this.disable){
      this.$emit('change', !this.state)
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkbox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: center;
  width: 80%;
  height: 33px;
  margin-bottom: -10px;
}
p {
  padding: 0 0 0 5px;
}
.switch {
  position: relative;
  width: 44px;
  height: 24px;
}
.switch input {
  display: none;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--o-text-label);
  transition: 0.4s;
  border-radius: 34px;
}
.slider:before {
  position: absolute;
  content: '';
  height: 19px;
  width: 19px;
  left: 2.5px;
  bottom: 2.5px;
  background-color: var(--o-text-on-bg);
  transition: 0.4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: var(--o-primary);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--o-primary);
}
input:checked + .slider:before {
  transform: translateX(20px);
}
</style>
